import eventBus from "@apexl/icarus-core/src/services/eventBus";

export default function (args, row, table) {
  eventBus.$emit('tabulator:filter', [{
    column: args.targetField,
    value: row.getData().filter,
  }])
}
